import React, { useState, useEffect } from "react";
import {connect} from 'react-redux';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import * as actions from "../store/actions";

function Tariffs(props){

    const [myData, setMyData] = useState([]);
    const [packageSelection, setPackageSelection] = useState(props.tariff);

    const server_00 = [
        {name: 'ALL PACKAGES', value: 8},
        {name: 'ALL PACKAGES-NO ADULT', value: 7},
        {name: 'ENGLISH-SPORTS-ADULT', value: 10},
        {name: 'ENGLISH-SPORTS-NO ADULT', value: 11},
        {name: 'ENGLISH-SPORTS-PORTUGUESE-ADULT', value: 12},
        {name: 'ENGLISH-SPORTS-PORTUGUESE-NO ADULT', value: 13},
        {name: 'ENGLISH-SPORTS-PORTUGUESE-BRAZIL-ADULT', value: 14},
        {name: 'ENGLISH-SPORTS-PORTUGUESE-BRAZIL-NO ADULT', value: 15},
        {name: 'ENGLISH-SPORTS-PORTUGUESE-BRAZIL-SPANISH-ADULT', value: 16},
        {name: 'ENGLISH-SPORTS-PORTUGUESE-BRAZIL-SPANISH-NO ADULT', value: 17},
        {name: 'ENGLISH-SPORTS-SOUTH_ASIAN-ADULT', value: 18},
        {name: 'ENGLISH-SPORTS-SOUTH_ASIAN-NO ADULT', value: 19},
        {name: 'ENG-SPORTS-HINDI-PUNJABI-URDU-ADULT', value: 48},
        {name: 'ENG-SPORTS-HINDI-PUNJABI-URDU-NO ADULT', value: 49},
        {name: 'ENGLISH-SPORTS-CARIBBEAN-ADULT', value: 20},
        {name: 'ENGLISH-SPORTS-CARIBBEAN-NO ADULT', value: 21},
        {name: 'ENGLISH-WEST INDIAN-ADULT', value: 22},
        {name: 'ENGLISH-WEST INDIAN-NO ADULT', value: 23},
        {name: 'ENGLISH-SPORTS-CARRIBEAN-AFRICAN-ADULT', value: 50},
        {name: 'ENGLISH-SPORTS-CARRIBEAN-AFRICAN-NO ADULT', value: 51},
        {name: 'ENG-SPORTS-EAST-ASIAN-ADULT', value: 26},
        {name: 'ENG-SPORTS-EAST-ASIAN-NO ADULT', value: 27},
        {name: 'ENG-SPORTS-EURO-ADULT', value: 28},
        {name: 'ENG-SPORTS-EURO-NO ADULT', value: 29},
        {name: 'ENG-SPORTS-ROMANIAN-HUNGARY-ADULT', value: 30},
        {name: 'ENG-SPORTS-ROMANIAN-HUNGARY-NO ADULT', value: 31},
        {name: 'ENG-HINDI-ADULT', value: 32},
        {name: 'ENG-HINDI-NO ADULT', value: 33},
        {name: 'ENG-SPORTS-ARABIC-ADULT', value: 34},
        {name: 'ENG-SPORTS-ARABIC-NO ADULT', value: 35},
        {name: 'ENG-SPORTS-AFRICA-ADULT', value: 36},
        {name: 'ENG-SPORTS-AFRICA-NO ADULT', value: 37},
        {name: 'ENG-SPORTS-SOUTH-INDIAN-ADULT', value: 38},
        {name: 'ENG-SPORTS-SOUTH-INDIAN-NO ADULT', value: 39},
        {name: 'ENG-SPORTS-EXYU-ADULT', value: 40},
        {name: 'ENG-SPORTS-EXYU-NO ADULT', value: 41},
        {name: 'ENG-SPORTS-RUSSSIA-ADULT', value: 42},
        {name: 'ENG-SPORTS-RUSSSIA-NO ADULT', value: 43},
        {name: 'ENG-SPORTS-LATINO-ADULT', value: 44},
        {name: 'ENG-SPORTS-LATINO-NO ADULT', value: 45},
        {name: 'ENG-SPORTS-POLISH-ADULT', value: 46},
        {name: 'ENG-SPORTS-POLISH-NO ADULT', value: 47},
        {name: 'ENG-SPORTS-HINDI-PUNJABI-URDU-ADULT', value: 48},
        {name: 'ENG-SPORTS-HINDI-PUNJABI-URDU-NO ADULT', value: 49},
        {name: 'ENGLISH-SPORTS-CARRIBEAN-AFRICAN-ADULT', value: 50},
        {name: 'ENGLISH-SPORTS-CARRIBEAN-AFRICAN-NO ADULT', value: 51},
        {name: 'ENG-SPORTS-ITALIAN-ADULT', value: 52},
        {name: 'ENG-SPORTS-ITALIAN-NO-ADULT', value: 53},
        {name: 'ENG-SPORTS-GREEK-ADULT', value: 54},
        {name: 'ENG-SPORTS-GREEK-NO-ADULT', value: 55},
        {name: 'CUSTOM PACKAGE SELECTION', value: 3}
    ];

    const server_01 = [
        {name: 'ALL PACKAGES', value: 8},
        {name: 'ALL PACKAGES-NO ADULT', value: 7},
        {name: 'ENGLISH-SPORTS-ADULT', value: 9},
        {name: 'ENGLISH-SPORTS-NO ADULT', value: 10},
        {name: 'ENGLISH-SPORTS-POLISH-ADULT', value: 11},
        {name: 'ENGLISH-SPORTS-POLISH-NO ADULT', value: 12},
        {name: 'ENGLISH-SPORTS-SOUTH_ASIAN-ADULT', value: 13},
        {name: 'ENGLISH-SPORTS-SOUTH_ASIAN-NO ADULT', value: 14},
        {name: 'ENGLISH-SPORTS-ITALIAN-ADULT', value: 15},
        {name: 'ENGLISH-SPORTS-ITALIAN-NO ADULT', value: 16},
        {name: 'ENGLISH-SPORTS-PORTUGUESE-ADULT', value: 17},
        {name: 'ENGLISH-SPORTS-PORTUGUESE-NO ADULT', value: 18},
        {name: 'ENGLISH-SPORTS-AFRICAN-ADULT', value: 19},
        {name: 'ENGLISH-SPORTS-AFRICAN-NO ADULT', value: 20},
        {name: 'ENGLISH-SPORTS-ARABIC-ADULT', value: 21},
        {name: 'ENGLISH-SPORTS-ARABIC-NO ADULT', value: 22},
        {name: 'CUSTOM PACKAGE SELECTION', value: 3}
    ];

    const server_02 = [
        {name: 'ALL PACKAGES', value: 8},
        {name: 'ALL PACKAGES-NO ADULT', value: 7},
        {name: 'ENGLISH-SPORTS-ADULT', value: 9},
        {name: 'ENGLISH-SPORTS-NO ADULT', value: 13},
        {name: 'ENGLISH-SPORTS-SOUTH_ASIAN-ADULT', value: 10},
        {name: 'ENGLISH-SPORTS-SOUTH_ASIAN-NO ADULT', value: 11},
        {name: 'ENGLISH-SPORTS-PORTUGUESE-BRAZIL-ADULT', value: 14},
        {name: 'ENGLISH-SPORTS-PORTUGUESE-BRAZIL-NO ADULT', value: 15},
        {name: 'ENGLISH-SPORTS-SPANISH-ADULT', value: 16},
        {name: 'ENGLISH-SPORTS-SPANISH-NO ADULT', value: 17},
        {name: 'ENG-SPORTS-PORTUGUESE-BRAZIL-ITALIAN-SPANISH-SOUTH-AMERICA-LATINO-ADULT', value: 18},
        {name: 'ENG-SPORTS-PORTUGUESE-BRAZIL-ITALIAN-SPANISH-SOUTH-AMERICA-LATINO-NO ADULT', value: 19},
        {name: 'ENG-SPORTS-SPANISH-PORTUGUESE-ITALIAN-ADULT', value: 20},
        {name: 'ENG-SPORTS-SPANISH-PORTUGUESE-ITALIAN-NO ADULT', value: 21},
        {name: 'ENGLISH-SPORTS-CARIBBEAN-ADULT', value: 22},
        {name: 'ENGLISH-SPORTS-CARIBBEAN-NO ADULT', value: 23},
        {name: 'ENGLISH-SPORTS-CARRIBEAN-SOUTH-AMERICA-ADULT', value: 25},
        {name: 'ENGLISH-SPORTS-CARRIBEAN-SOUTH-AMERICA-NO ADULT', value: 24},
        {name: 'ENG-SPORTS-EXYU-ADULT', value: 26},
        {name: 'ENG-SPORTS-EXYU-ADULT-NO ADULT', value: 27},
        {name: 'ENG-SPORTS-PORTUGUESE-BRAZIL-ITLIAN-SPANISH-ADULT', value: 28},
        {name: 'ENG-SPORTS-PORTUGUESE-BRAZIL-ITLIAN-SPANISH-NO ADULT', value: 32},
        {name: 'ENG-SPORTS-ITALIAN-ADULT', value: 33},
        {name: 'ENG-SPORTS-ITALIAN-NO-ADULT', value: 34},
        {name: 'ENG-SPORTS-LATINO-MEXICAN-SPANISH-SOUTH-AMERICA-ADULT', value: 35},
        {name: 'ENG-SPORTS-LATINO-MEXICAN-SPANISH-SOUTH-AMERICA-NO-ADULT', value: 36},
        {name: 'ENG-SPORTS-ARABIC-ADULT', value: 38},
        {name: 'ENG-SPORTS-ARABIC-NO-ADULT', value: 37},
        {name: 'ENG-SPORTS-GREEK-ADULT', value: 39},
        {name: 'ENG-SPORTS-GREEK-NO-ADULT', value: 40},
        {name: 'ENG-SPORTS-POLISH-ROMANIAN-EXYU-ADULT', value: 41},
        {name: 'ENG-SPORTS-POLISH-ROMANIAN-EXYU-NO-ADULT', value: 42},
        {name: 'ENG-SPORTS-FRENCH_CA-AFRICAN-FRENCH-ADULT', value: 44},
        {name: 'ENG-SPORTS-FRENCH_CA-AFRICAN-FRENCH-NO-ADULT', value: 43},
        {name: 'ENG-SPORTS-VIETNAMESE-KOREAN-CHINESE-FILIPINO-ADULT', value: 48},
        {name: 'ENG-SPORTS-VIETNAMESE-KOREAN-CHINESE-FILIPINO-NO-ADULT', value: 47},
        {name: 'ENG-SPORTS-HINDI-URDU-PUNJABI-ADULT', value: 49},
        {name: 'ENG-SPORTS-HINDI-URDU-PUNJABI-NO-ADULT', value: 50},
        {name: 'CUSTOM PACKAGE SELECTION', value: 3}
    ];

    useEffect(() => {
        console.log('LOGGING server selection', props.s);
        if (props.s == 0) {
            //console.log('setting server 0');
            setMyData(server_00);
            setPackageSelection(8);
        } else if (props.s == 1) {
            //console.log('setting server 1');
            setMyData(server_01);
            setPackageSelection(8);
        } else if (props.s == 2) {
            //console.log('setting server 1');
            setMyData(server_02);
            setPackageSelection(8);
        }
    },[props.s]);

    useEffect(() => {
        console.log('LOGGING setting tariff', packageSelection);
        props.onSetTariff(packageSelection); 
    }, [packageSelection]);

    useEffect(() => {
        console.log('tariff changed', props.tariff);
        setPackageSelection(props.tariff); 
    }, [props.tariff]);
    
    return (

        <Select
            id="listOfPackages"
            name="listOfPackages"
            value={packageSelection}
            onChange={e => setPackageSelection(e.target.value)}
        >
            {myData.map((data) => (
            <MenuItem value={data.value} key={"tariff_" + data.value}>{data.name}</MenuItem>
            ))}
        </Select>
        
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onSetTariff: (tariff) => dispatch(actions.setTariff(tariff))
    }
};

const mapStateToProps = state => {
    return {
        currentClient: state.clientReducer.client,
        tariff: state.tariff.tariff_plan
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Tariffs);